<template>
  <div class="cdcb-wrap">
    <div class="tree-content box" v-show="tabShow">
      <tab-tree :data="viewTreeData" @tabTreeDefault="tabTreeDefault" @tabTreeClick="tabTreeClick"></tab-tree>
    </div>
    <div class="content" :style="{width:tabShow?'calc(100% - 260px)':'100%'}">
      <div class="search-box box">
        <time-search ref="timeSearch" :control="{data:timeType}" @timeControlChange="timeControlChange" @timeControlClick="TimeControlClick"></time-search>
      </div>
      <div class="grid-content">
        <btn-show @show="tabShow = !tabShow" content="左边树"></btn-show>
        <div class="main">
          <field :selectedMeasure.sync="selectedMeasure" :timeElem="timeElem" ref="field"></field>
          <div class="main-tab">
            <el-tag :type="tabType== 0 ?'':'info'" @click="switchTab(0)" class="tag" :hit="true">用量明细</el-tag>
            <el-tag :type="tabType== 1 ?'':'info'" @click="switchTab(1)" class="tag" :hit="true">用量趋势</el-tag>
          </div>
          <div class="main-table">
            <cdcbTable v-if="tabType == 0" :selectedMeasure.sync="selectedMeasure" :timeElem="timeElem" ref="cdcbTable"></cdcbTable>
            <cdcbLine v-else :selectedMeasure.sync="selectedMeasure" :timeElem="timeElem" ref="cdcbLine"></cdcbLine>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TabTree from "@/components/common/TabTree.vue";
import { findDataByParam } from "@/utils/index.js";
import TimeSearch from "@/components/common/TimeSearch.vue";
import BtnShow from "@/components/common/BtnShow.vue";
import * as utils from "@/utils/index.js";
import field from "./components/field";
import cdcbTable from "./components/cdcbTable";
import cdcbLine from "./components/cdcbLine";
export default {
  name: "cdcb",
  components: {
    TabTree, TimeSearch, BtnShow, field, cdcbTable, cdcbLine
  },
  data () {
    return {
      treeAddress: "/report/cdcb",
      viewTreeData: [],//树数据
      selectedMeasure: {//当前选中的树数据
        measureId: "",
        measureName: "",
      },
      timeElem: {},//当前的时间参数
      tabShow: true,//左边的树是否显示
      timeType: [//时间类型
        { type: "day", label: "日" },
        { type: "month", label: "月" },
        { type: "year", label: "年" }
      ],
      tabType: 0,//默认选中的选项卡
    }
  },
  mounted () {
    this.getTreeData();//获取树数据
  },
  methods: {
    async getTreeData () {//获取树数据
      let res = await this.$api.frontEndPageCustomParam.getMyFrontEndPageCustomParam(this.$store.state.user.currentCompanyId, this.treeAddress, null);
      this.viewTreeData = findDataByParam("viewTree", true, res.data);//数据赋值
    },
    tabTreeDefault (e) {//首次加载树时执行，保留默认的树选择
      this.selectedMeasure = Object.assign({}, e);
      this.getData();
    },
    tabTreeClick (e) {//树节点点击的时候触发
      this.selectedMeasure = Object.assign({}, e);
      this.getData();
    },
    timeControlChange (e) {//时间下拉框切换时触发
      this.timeElem = Object.assign({}, e);
    },
    TimeControlClick (e) {//时间点击查询时
      this.timeElem = Object.assign({}, e);
      this.getData();
    },
    switchTab (type) {
      this.tabType = type;
      this.$nextTick(() => {
        if (this.tabType == 0) {
          this.$refs.cdcbTable.getData();//查询表格信息
        } else {
          this.$refs.cdcbLine.getData();//查询折线图信息
        }
      });
    },
    async getData () {//开始查询数据
      setTimeout(() => {
        this.$refs.field.getData();//查询同环比等信息
        if (this.tabType == 0) {
          this.$refs.cdcbTable.getData();//查询表格信息
        } else {
          this.$refs.cdcbLine.getData();//查询折线图信息
        }
      }, 0);
    }
  },
}
</script>

<style lang="scss" scoped>
.cdcb-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
  padding: 23px;
  box-sizing: border-box;
  .tree-content {
    width: 260px;
    margin-right: 14px;
  }
  .content {
    position: relative;
    .search-box {
      height: 36px;
      .option {
        width: 150px;
        margin: 0 0 0 10px;
      }
    }
    .grid-content {
      position: absolute;
      bottom: 0;
      width: 100%;
      top: 50px;
      .main {
        width: 100%;
        height: 100%;
        display: flex;
        flex-flow: column;
        .main-tab {
          background: #fff;
          width: 100%;
          border-radius: 4px;
          box-sizing: border-box;
          overflow: hidden;
          padding: 10px;
          text-align: left;
          color: #333;
          margin-top: 14px;
          .tag {
            cursor: pointer;
            margin-right: 10px;
          }
        }
        .main-table {
          width: 100%;
          flex: 1;
          margin-top: 14px;
        }
      }
    }
  }
}
</style>